import React from 'react';
import Card from '../../ui/Card';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ZAxis, Cell, ReferenceLine } from 'recharts';
const PricePositioningScatter: React.FC = () => {
  const data = [{
    company: 'Our Company',
    price: 92,
    quality: 88,
    marketShare: 12.8,
    color: '#3b82f6'
  }, {
    company: 'Competitor A',
    price: 78,
    quality: 82,
    marketShare: 18.5,
    color: '#ef4444'
  }, {
    company: 'Competitor B',
    price: 95,
    quality: 92,
    marketShare: 15.2,
    color: '#10b981'
  }, {
    company: 'Competitor C',
    price: 85,
    quality: 78,
    marketShare: 9.8,
    color: '#f59e0b'
  }, {
    company: 'Competitor D',
    price: 88,
    quality: 85,
    marketShare: 11.2,
    color: '#8b5cf6'
  }, {
    company: 'Competitor E',
    price: 72,
    quality: 75,
    marketShare: 7.5,
    color: '#ec4899'
  }, {
    company: 'Competitor F',
    price: 98,
    quality: 95,
    marketShare: 13.8,
    color: '#06b6d4'
  }];
  return <Card className="p-6" data-id="element-7892">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-7893">
        Price vs Quality Positioning
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-7894">
        Competitive landscape (Bubble size = Market Share %)
      </p>
      <ResponsiveContainer width="100%" height={350} data-id="element-7895">
        <ScatterChart data-id="element-7896">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-7897" />
          <XAxis type="number" dataKey="price" name="Price Index" tick={{
          fontSize: 12
        }} label={{
          value: 'Price Competitiveness Index →',
          position: 'insideBottom',
          offset: -5,
          fontSize: 12
        }} domain={[65, 105]} data-id="element-7898" />
          <YAxis type="number" dataKey="quality" name="Quality Index" tick={{
          fontSize: 12
        }} label={{
          value: 'Quality Perception Index →',
          angle: -90,
          position: 'insideLeft',
          fontSize: 12
        }} domain={[70, 100]} data-id="element-7899" />
          <ZAxis type="number" dataKey="marketShare" range={[400, 2500]} name="Market Share" data-id="element-7900" />
          <Tooltip cursor={{
          strokeDasharray: '3 3'
        }} contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: any, name: string) => {
          if (name === 'Market Share') return `${value}%`;
          return value;
        }} data-id="element-7901" />
          <Legend data-id="element-7902" />
          <ReferenceLine x={85} stroke="#9ca3af" strokeDasharray="3 3" label={{
          value: 'Avg Price',
          position: 'top',
          fontSize: 10
        }} data-id="element-7903" />
          <ReferenceLine y={85} stroke="#9ca3af" strokeDasharray="3 3" label={{
          value: 'Avg Quality',
          position: 'right',
          fontSize: 10
        }} data-id="element-7904" />
          <Scatter name="Companies" data={data} data-id="element-7905">
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-7906" />)}
          </Scatter>
        </ScatterChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7907">
        <div className="grid grid-cols-2 gap-4" data-id="element-7908">
          <div data-id="element-7909">
            <div className="text-xs text-gray-600 mb-2" data-id="element-7910">Our Position</div>
            <div className="flex items-center space-x-4" data-id="element-7911">
              <div data-id="element-7912">
                <div className="text-xs text-gray-500" data-id="element-7913">Price Index</div>
                <div className="text-lg font-bold text-blue-600" data-id="element-7914">92</div>
              </div>
              <div data-id="element-7915">
                <div className="text-xs text-gray-500" data-id="element-7916">Quality Index</div>
                <div className="text-lg font-bold text-blue-600" data-id="element-7917">88</div>
              </div>
              <div data-id="element-7918">
                <div className="text-xs text-gray-500" data-id="element-7919">Market Share</div>
                <div className="text-lg font-bold text-blue-600" data-id="element-7920">12.8%</div>
              </div>
            </div>
          </div>
          <div data-id="element-7921">
            <div className="text-xs text-gray-600 mb-2" data-id="element-7922">Strategic Quadrant</div>
            <div className="text-sm font-semibold text-gray-800 bg-blue-50 px-3 py-2 rounded-lg" data-id="element-7923">
              High Price / High Quality - Premium Positioning
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-2 text-xs" data-id="element-7924">
        <div className="flex items-center" data-id="element-7925">
          <div className="w-3 h-3 rounded-full bg-green-500 mr-2" data-id="element-7926" />
          <span className="text-gray-600" data-id="element-7927">High Price / High Quality</span>
        </div>
        <div className="flex items-center" data-id="element-7928">
          <div className="w-3 h-3 rounded-full bg-yellow-500 mr-2" data-id="element-7929" />
          <span className="text-gray-600" data-id="element-7930">Low Price / High Quality</span>
        </div>
        <div className="flex items-center" data-id="element-7931">
          <div className="w-3 h-3 rounded-full bg-blue-500 mr-2" data-id="element-7932" />
          <span className="text-gray-600" data-id="element-7933">High Price / Low Quality</span>
        </div>
        <div className="flex items-center" data-id="element-7934">
          <div className="w-3 h-3 rounded-full bg-red-500 mr-2" data-id="element-7935" />
          <span className="text-gray-600" data-id="element-7936">Low Price / Low Quality</span>
        </div>
      </div>
    </Card>;
};
export default PricePositioningScatter;